import styled, { css } from 'styled-components';
import { Card } from '../Card/index.js';
import { elevation } from '../Styles/Utils/elevation.js';

const Box = styled(Card).withConfig({
    displayName: "styled__Box",
    componentId: "sc-27da14b3-0"
})`
    display: flex;
    user-select: none;
    cursor: pointer;
    position: relative;
`;
const Details = styled.div.withConfig({
    displayName: "styled__Details",
    componentId: "sc-27da14b3-1"
})`
    overflow: hidden;
    flex: 1 1 auto;
    padding-right: 16px;
    display: flex;
    justify-content: center;
    flex-direction: column;
`;
const ImageContainer = styled.div.withConfig({
    displayName: "styled__ImageContainer",
    componentId: "sc-27da14b3-2"
})`
    height: 96px;
    width: 96px;
    flex-shrink: 0;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;

    ${(props)=>props.subdued ? css`
                  height: 48px;
                  width: 48px;
              ` : ""}
`;
const ImagePlaceholder = styled.div.withConfig({
    displayName: "styled__ImagePlaceholder",
    componentId: "sc-27da14b3-3"
})`
    height: 96px;
    width: 96px;
    flex-shrink: 0;
    border-radius: 4px;
    background-color: ${(props)=>props.theme.colors["Level 1"]};

    ${(props)=>props.subdued ? css`
                  height: 48px;
                  width: 48px;
              ` : ""}
`;
const Title = styled.span.withConfig({
    displayName: "styled__Title",
    componentId: "sc-27da14b3-4"
})`
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;

    color: ${(props)=>props.theme.colors.Foreground};
    ${(props)=>css(props.theme.typography.SuperTinyHeadline)}

    ${(props)=>props.subdued ? css`
                  color: ${props.theme.colors["Level 4"]};
              ` : ""}
`;
const TitleWrapper = styled.div.withConfig({
    displayName: "styled__TitleWrapper",
    componentId: "sc-27da14b3-5"
})`
    display: flex;
    margin-bottom: ${(props)=>props.theme.spacers.S};
    align-items: center;
`;
const DotColor = styled.div.withConfig({
    displayName: "styled__DotColor",
    componentId: "sc-27da14b3-6"
})`
    width: 16px;
    height: 16px;
    flex: 0 0 auto;

    border-radius: 50%;
    box-sizing: border-box;
    ${elevation(2, false)}

    ${(props)=>css`
        background-color: ${props.dotColor};
        border: 2px solid ${props.theme.colors.ElementBackground};
        margin-left: ${props.theme.spacers.M};
    `}
`;
const RippleContainer = styled.div.withConfig({
    displayName: "styled__RippleContainer",
    componentId: "sc-27da14b3-7"
})`
    border-radius: 4px;
    width: 100%;
    height: 100%;
    position: absolute !important;
    top: 0;
    left: 0;
`;
const SwapIconWrap = styled.div.withConfig({
    displayName: "styled__SwapIconWrap",
    componentId: "sc-27da14b3-8"
})`
    position: absolute;
    right: 8px;
    top: 8px;
    height: 32px;
    width: 32px;
    border-radius: 16px;
    background-color: ${(props)=>props.theme.colors.secondaryBackground};
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    z-index: 10;
`;

export { Box, Details, DotColor, ImageContainer, ImagePlaceholder, RippleContainer, SwapIconWrap, Title, TitleWrapper };
